import { getSortedRaceResults } from 'src/utils/raceUtils'
import type { Race } from 'src/types/domain/Race'
import type { Marble } from 'src/types/domain/Marble'
import { RaceBannerResultEntry } from './RaceBannerResultEntry'
import { RaceBannerWinner } from './RaceBannerWinner'

type Props = Readonly<{
  marbles: Marble[]
  race: Race
  winnerOnly: boolean
}>

export function RaceBannerResults({ marbles, race, winnerOnly }: Props) {
  const marbleResults = getSortedRaceResults(race, marbles)

  if (!marbleResults || !marbleResults[0]) return null

  if (winnerOnly) {
    return (
      <div className="result_entries result_entries-winner-only">
        <RaceBannerWinner marble={marbleResults[0].marble} />
      </div>
    )
  }

  return (
    <div className="result_entries">
      {marbleResults.slice(0, 3).map((result) => (
        <RaceBannerResultEntry
          key={result.position}
          marble={result.marble}
          position={result.position}
        />
      ))}
    </div>
  )
}
